<template>
  <div class="tabla">
    <!-- Prueba tabla -->
    <div class="panel panel-flat">
      <div class="panel-body" style="text-align: center;">
        <span style="font-weight: 700; font-size: 16px; font-family: arial;">Stock disponible</span>
         <!-- SELECT -->
        <div class="row" style="text-align: left;">
          <div class="col-lg-3" style="display: inline-block">
            <span style="font-size: 16px; font-family: arial;float: left;margin-top: 7px;margin-right: 9px;" for="selectAlmacen">Almacén:</span>
            <select
              id="selectAlmacen"
              class="form-control form-control-sm"
              style="max-width: 300px;"
              ref="ialmacen"
              v-model="almacenid"
              @change="almacenChange()"
            >
              <option value="-1">Todos</option>
              <option
                v-for="almacen in almacenes"
                :key="Number(Object.keys(almacen))"
                :value="Number(Object.keys(almacen))"
              >{{ String(Object.values(almacen)) }}</option>
            </select>
          </div>
          <div class="col-lg-3" style="display: inline-block">
            <span style="font-size: 16px; font-family: arial;float: left;margin-top: 7px;margin-right: 9px;" for="selectTemporada">Temporada:</span>
            <select
              id="selectTemporada"
              class="form-control form-control-sm"
              style="max-width: 300px;"
              ref="itemporada"
              v-model="temporadaid"
              @change="temporadaChange()"
            >
              <option value="-1">Todos</option>
              <option
                v-for="temporada in temporadas"
                :key="Number(Object.keys(temporada))"
                :value="Number(Object.keys(temporada))"
              >{{ String(Object.values(temporada)) }}</option>
            </select>
          </div>
        </div>
        <br />
        <!-- /SELECT -->
        <div class="row">
          <div class="col-lg-4">
            <JqxLoader
              ref="jqxLoaderd1"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 180px"
              ref="donut1"
              :title="'Stock por familia'"
              :description="''"
              :showLegend="false"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataD1"
              :showToolTips="true"
              :seriesGroups="seriesGroupsDs"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
          </div>
          <div class="col-lg-4">
            <JqxLoader
              ref="jqxLoaderd2"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 180px"
              ref="donut2"
              :title="'Stock por subfamilia'"
              :description="''"
              :showLegend="false"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataD2"
              :showToolTips="true"
              :seriesGroups="seriesGroupsDs"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
          </div>
          <div class="col-lg-4">
            <JqxLoader
              ref="jqxLoaderd3"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 180px"
              ref="donut3"
              :title="'Stock por marca'"
              :description="''"
              :showLegend="false"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataD3"
              :showToolTips="true"
              :seriesGroups="seriesGroupsDs"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
          </div>
        </div>
        <br />
        <JqxLoader
          ref="jqxLoader"
          :imagePosition="'top'"
          :width="100"
          :height="60"
          :theme="'custom'"
          :text="'Cargando...'"
        ></JqxLoader>
        <JqxGrid
          ref="tablaStocks"
          :width="width"
          :height="heightTabla"
          :source="dataAdapter"
          :columns="columns"
          :filterable="true"
          :autoshowfiltericon="true"
          :sorting="true"
          :sortable="true"
          :groupable="true"
          :localization="localization"
          :showfilterrow="true"
          :selectionmode="'multiplecellsadvanced'"
          :scrollmode="'deferred'"
          :deferreddatafields="['movimiento','familia','subfamilia','marca']"
          :altrows="true"
          :autosavestate="true"
          :autoshowloadelement="false"
          :closeablegroups="false"
          :showgroupaggregates="true"
          :showstatusbar="true"
          :showaggregates="true"
          :statusbarheight="25"
          :columnsresize="true"
          :theme="'custom'"
          :enabletooltips="true"
        ></JqxGrid>
        <div style="margin-top: 20px">
          <div style="margin-left: 10px; float: left">
            <JqxButton :theme="'custom'" @click="imprimir()">Imprimir</JqxButton>
          </div>
          <div style="margin-left: 10px; float: left">
            <JqxButton :theme="'custom'" @click="exportarXls()">Exportar .xls</JqxButton>
          </div>
        </div>
      </div>
    </div>
    <!-- /Prueba tabla -->
  </div>
</template>
<script>

import XLSX from 'xlsx';
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import JqxButton from "jqwidgets-scripts/jqwidgets-vue/vue_jqxbuttons.vue";
import JqxLoader from "jqwidgets-scripts/jqwidgets-vue/vue_jqxloader.vue";
import JqxChart from "jqwidgets-scripts/jqwidgets-vue/vue_jqxchart.vue";
import { Util } from "@/api/Util";

import { BiApiService } from "@/api/BiApiService";
const util = new Util();

const biApiService = new BiApiService();

export default {
  components: {
    JqxGrid,
    JqxButton,
    JqxLoader,
    JqxChart
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      tipomovimiento: 1, // Stock
      localization: this.getLocalization(),
      lang: this.$store.getters.lang,
      // eslint-disable-next-line
      dataAdapter: new jqx.dataAdapter(this.source),
      width: "100%",
      selectionmode: "multiplerowsextended",
      showaggregates: true,
      // Donuts
      dataD1: [],
      dataD2: [],
      dataD3: [],
      seriesGroupsDs: [
        {
          type: "donut",
          useGradient: false,
          useGradientColors: false,
          series: [
            {
              showLabels: false,
              enableSelection: true,
              displayText: "text",
              dataField: "value",
              labelRadius: 120,
              initialAngle: 90,
              radius: 60,
              innerRadius: 50,
              centerOffset: 0
            }
          ]
        }
      ],
      padding: { left: 5, top: 5, right: 5, bottom: 5 },
      titlePadding: { left: 5, top: 5, right: 5, bottom: 5 },
      // /Donuts
      columns: [
        {
          text: "Familia",
          dataField: "familia",
          width: "9%",
          groupable:"true",
          filtertype: "checkedlist"
        },
        {
          text: "Subfamilia",
          dataField: "subfamilia",
          width: "9%",
          groupable:"true",
          filtertype: "checkedlist"
        },
        {
          text: "Marca",
          dataField: "marca",
          width: "9%",
          groupable:"true",
          filtertype: "checkedlist"
        },
        // TOTALES
        {
          text: "Total",
          dataField: "total",
          width: "5%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          /*aggregates: [
            {
              "": (aggregatedValue, currentValue) => {
                var total = currentValue;
                return aggregatedValue + total;
              }
            }
          ],
          aggregatesrenderer: this.aggregatesrenderer*/
          // ,groupsrenderer: this.groupsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
                var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
                + '</div>';
                return renderstring;
          }
        },
        {
          text: "Total SL",
          dataField: "total_sl",
          width: "5%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "R",
          dataField: "r",
          width: "5%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "U",
          dataField: "u",
          width: "5%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL1",
          dataField: "sl1",
          width: "5%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL2",
          dataField: "sl2",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL3",
          dataField: "sl3",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL4",
          dataField: "sl4",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL5",
          dataField: "sl5",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL6",
          dataField: "sl6",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL7",
          dataField: "sl7",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL8",
          dataField: "sl8",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL9",
          dataField: "sl9",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL10",
          dataField: "sl10",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL11",
          dataField: "sl11",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL12",
          dataField: "sl12",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        },
        {
          text: "SL13",
          dataField: "sl13",
          width: "4%",
          cellsalign: "right",
          cellsformat: "d",
          //cellsrenderer: this.cellsrenderer,
          aggregates: ['sum'],
          cellsrenderer: (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
                        },
          aggregatesrenderer: (aggregates) => {
              var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + ((aggregates.sum!==undefined) ? aggregates.sum : " ")
              + '</div>';
              return renderstring;
          }
        }
        // /TOTALES
      ],
      id: "row",
      tableData: [],
      almacenes: [],
      temporadas: [],
      almacenid: -1,
      temporadaid: -1,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  beforeCreate: function() {
    this.source = {
      localdata: [],
      autoloadstate: false,
      datafields: [
        { name: "row", type: "number" },
        //{ name: "almacen", type: "string" },
        // { name: "tipo", type: "string" },
        // { name: "seccion", type: "string" },
        { name: "familia", type: "string" },
        { name: "subfamilia", type: "string" },
        // { name: "modelo", type: "string" },
        // { name: "color", type: "string" },
        // { name: "localizador", type: "number" },
        // { name: "temporada", type: "string" },
        { name: "marca", type: "string" },
        // TOTALES
        { name: "total", type: "number" },
        { name: "total_sl", type: "number" },
        { name: "r", type: "number" },
        { name: "u", type: "number" },
        { name: "sl1", type: "number" },
        { name: "sl2", type: "number" },
        { name: "sl3", type: "number" },
        { name: "sl4", type: "number" },
        { name: "sl5", type: "number" },
        { name: "sl6", type: "number" },
        { name: "sl7", type: "number" },
        { name: "sl8", type: "number" },
        { name: "sl9", type: "number" },
        { name: "sl10", type: "number" },
        { name: "sl11", type: "number" },
        { name: "sl12", type: "number" },
        { name: "sl13", type: "number" }
        // /TOTALES
      ],
      datatype: "array"
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getAlmacenIdCookie();
    this.getTemporadaIdCookie();
  },
  mounted() {
    // this.generatedata(50);
    this.getAllAlmacen();
    this.getAllTemporada();
    //this.getAllStockByAlmacenId();
    //this.getAllTotalPorFamiliaByTipoMovimiento(this.tipomovimiento);
    //this.getAllTotalPorSubfamiliaByTipoMovimiento(this.tipomovimiento);
    //this.getAllTotalPorAlmacenByTipoMovimiento(this.tipomovimiento);
    
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getAlmacenIdCookie() {
      if (this.$cookies.get("almacenid") !== null) {
        this.almacenid = this.$cookies.get("almacenid");
      }
    },
    getTemporadaIdCookie() {
      if (this.$cookies.get("temporadaid") !== null) {
        this.temporadaid = this.$cookies.get("temporadaid");
      }
    },
    generatedata(num) {
      let data = [];
      let count = 0;
      for (let i = 0; i <= num; i++) {
        if (count < 5) {
          count++;
        } else {
          count = 0;
        }
        const dataItem = {
          firstname: `Nombre ${count}`,
          lastname: `Apellido ${i}`,
          productname: `Producto ${i}`,
          quantity: Math.floor(Math.random() * (10 - 1 + 1)) + 1,
          price: Math.floor(Math.random() * (200 - 1 + 1)) + 1,
          total: Math.floor(Math.random() * (50 - 1 + 1)) + 1
        };
        data.push(dataItem);
      }
      return data;
    },
    imprimir: function() {
      let gridContent = this.$refs.tablaStocks.exportdata("html");
      let newWindow = window.open("", "", "width=800, height=500"),
        document = newWindow.document.open(),
        pageContent =
          "<!DOCTYPE html>\n" +
          "<html>\n" +
          "<head>\n" +
          '<meta charset="utf-8" />\n' +
          "<title>jQWidgets Grid</title>\n" +
          "</head>\n" +
          "<body>\n" +
          gridContent +
          "\n</body>\n</html>";
      document.write(pageContent);
      document.close();
      newWindow.print();
    },
    exportarXls: function() {
      let gridContent = JSON.parse(this.$refs.tablaStocks.exportdata("json"))

      let data = XLSX.utils.json_to_sheet(gridContent)
      const workbook = XLSX.utils.book_new()
      const filename = 'stock-disponible'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    exportarPdf: function() {
      this.$refs.tablaStocks.exportdata("pdf", "jqxGrid");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getAllTemporada() {
      biApiService
        .getAllTemporada()
        .then(data => {
          this.temporadas = data;
          // Si no está almacenado en cookie el temporadaid, cogemos el primer registro
          if (this.temporadaid === undefined || this.temporadaid === 0 || this.temporadaid === null){
             // if (this.temporadas.length > 0){
            //     this.temporadaid = Object.keys(this.temporadas[0])[0]; 
            // } 
            this.temporadaid = -1
          }
          this.getAllStockByAlmacenIdandTempId();
          this.getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
          this.getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
          this.getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
          util.mostrarEnConsola(
            "TablaStock - getAllTemporada",
            data.length,
            "OK"
          );
        })
        .catch(error => {
          util.mostrarEnConsola("TablaStock - getAllTemporada", error, "ERROR");
        });
    },
    temporadaChange() {
      this.$cookies.set("temporadaid", Number(this.temporadaid));
      this.getAllStockByAlmacenIdandTempId();
      this.getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
      this.getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
      this.getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
    },
    getAllAlmacen() {
      biApiService
        .getAllAlmacen()
        .then(data => {
          this.almacenes = data;
          // Si no está almacenado en cookie el almacenid, cogemos el primer registro
          if (this.almacenid === undefined || this.almacenid === 0 || this.almacenid === null){
            // if (this.almacenes.length > 0){
            //     this.almacenid = Object.keys(this.almacenes[0])[0]; 
            // } 
            this.almacenid = -1
          }
          util.mostrarEnConsola(
            "TablaStock - getAllAlmacen",
            data.length,
            "OK"
          );
        })
        .catch(error => {
          util.mostrarEnConsola("TablaStock - getAllAlmacen", error, "ERROR");
        });
    },
    almacenChange() {
      this.$cookies.set("almacenid", Number(this.almacenid));
      this.getAllStockByAlmacenIdandTempId();
      this.getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
      this.getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
      this.getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(this.tipomovimiento);
    },
    getAllStockByAlmacenIdandTempId() {
      this.$refs.jqxLoader.open();
      biApiService
        .getAllStockByAlmacenIdandTempId(this.almacenid, this.temporadaid)
        .then(data => {
          this.source.localdata = data;
          // passing `cells` to the `updatebounddata` method will refresh only the cells values when the new rows count is equal to the previous rows count.
          this.$refs.tablaStocks.updatebounddata();
          util.mostrarEnConsola("TablaStock - getAllStockByAlmacenIdandTempId", data.length, "OK");
          this.$refs.jqxLoader.close();
        })
        .catch(error => {
          util.mostrarEnConsola("TablaStock - getAllStockByAlmacenIdandTempId", error, "ERROR");
          this.$refs.tablaStocks.clear();
          this.$refs.jqxLoader.close();
        });
    },
    refreshBtnOnClick: function() {
      this.getAllStockByAlmacenIdandTempId();
    },
    getLocalization() {
      let traduccion = {
        // separator of parts of a date (e.g. '/' in 11/05/1955)
        "/": "/",
        // separator of parts of a time (e.g. ':' in 05:44 PM)
        ":": ":",
        // the first day of the week (0 = Sunday, 1 = Monday, etc)
        firstDay: 0,
        days: {
          // full day names
          names: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          // abbreviated day names
          namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          // shortest day names
          namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        },
        months: {
          // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
          names: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            ""
          ],
          // abbreviated month names
          namesAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            ""
          ]
        },
        // AM and PM designators in one of these forms:
        // The usual view, and the upper and lower case versions
        //      [standard,lowercase,uppercase]
        // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
        //      null
        AM: ["AM", "am", "AM"],
        PM: ["PM", "pm", "PM"],
        eras: [
          // eras in reverse chronological order.
          // name: the name of the era in this culture (e.g. A.D., C.E.)
          // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
          // offset: offset in years from gregorian calendar
          { name: "A.D.", start: null, offset: 0 }
        ],
        twoDigitYearMax: 2029,
        patterns: {
          // short date pattern
          d: "M/d/yyyy",
          // long date pattern
          D: "dddd, MMMM dd, yyyy",
          // short time pattern
          t: "h:mm tt",
          // long time pattern
          T: "h:mm:ss tt",
          // long date, short time pattern
          f: "dddd, MMMM dd, yyyy h:mm tt",
          // long date, long time pattern
          F: "dddd, MMMM dd, yyyy h:mm:ss tt",
          // month/day pattern
          M: "MMMM dd",
          // month/year pattern
          Y: "yyyy MMMM",
          // S is a sortable format that does not vary by culture
          S:
            "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss"
        },
        percentsymbol: "%",
        currencysymbol: " €",
        currencysymbolposition: "after",
        decimalseparator: ",",
        thousandsseparator: ".",
        pagergotopagestring: "Ir a la página:",
        pagershowrowsstring: "Nº de filas:",
        pagerrangestring: " de ",
        pagerpreviousbuttonstring: "Anterior",
        pagernextbuttonstring: "Siguiente",
        groupsheaderstring:
          "Arrastra el nombre de una columna aquí para agrupar los datos por dicha columna",
        sortascendingstring: "Ordenar asc.",
        sortdescendingstring: "Ordenar desc.",
        sortremovestring: "Quitar ordenación",
        groupbystring: "Agrupar por esta columna",
        groupremovestring: "Quitar agrupación",
        filterclearstring: "Limpiar",
        filterstring: "Filtrar",
        filtershowrowstring: "Mostrar filas que:",
        filtershowrowdatestring: "Show rows where date:",
        filterorconditionstring: "O",
        filterandconditionstring: "Y",
        filterselectallstring: "(Seleccionar todo)",
        filterchoosestring: "Por favor, elija:",
        filterstringcomparisonoperators: [
          "vacío",
          "no vacío",
          "contiene",
          "contiene(coincidir mayús.)",
          "no contiene",
          "no contiene(coincidir mayús.)",
          "comienza por",
          "comienza por(coincidir mayús.)",
          "termina en",
          "termina en(coincidir mayús.)",
          "igual a",
          "igual a(coincidir mayús.)",
          "nulo",
          "no nulo"
        ],
        filternumericcomparisonoperators: [
          "igual",
          "distinto",
          "menor que",
          "menor o igual que",
          "mayor que",
          "mayor o igual que",
          "nulo",
          "no nulo"
        ],
        filterdatecomparisonoperators: [
          "igual",
          "distinto",
          "menor que",
          "menor o igual que",
          "mayor que",
          "mayor o igual que",
          "nulo",
          "no nulo"
        ],
        filterbooleancomparisonoperators: ["igual", "distinto"],
        validationstring: "El valor introducido no es válido",
        emptydatastring: "No hay resultados",
        filterselectstring: "Seleccione filtro",
        loadtext: "Cargando...",
        clearstring: "Limpiar",
        todaystring: "Hoy"
      };
      return traduccion;
    },
    getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(tipo) {
      this.$refs.jqxLoaderd1.open();
      biApiService
        .getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId(tipo,this.almacenid,this.temporadaid)
        .then(data => {
          if (data.length > 0) {
            while (this.dataD1.length){
              this.dataD1.pop();
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];

              this.dataD1.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
            }
            this.$refs.donut1.update();
          }
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId",
            data.length,
            "OK"
          );
          this.$refs.jqxLoaderd1.close();
        })
        .catch(error => {
          while (this.dataD1.length){
              this.dataD1.pop();
          }
          this.$refs.donut1.update();
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorFamiliaByTipoMovimientoByAlmacenIdandTempId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd1.close();
        });
    },
    getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(tipo) {
      this.$refs.jqxLoaderd2.open();
      biApiService
        .getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId(tipo,this.almacenid,this.temporadaid)
        .then(data => {
          if (data.length > 0) {
            while (this.dataD2.length){
              this.dataD2.pop();
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];

              this.dataD2.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
            }
            this.$refs.donut2.update();
          }
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId",
            data.length,
            "OK"
          );
          this.$refs.jqxLoaderd2.close();
        })
        .catch(error => {
          while (this.dataD2.length){
              this.dataD2.pop();
          }
          this.$refs.donut2.update();
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorSubfamiliaByTipoMovimientoByAlmacenIdandTempId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd2.close();
        });
    },
    /*getAllTotalPorAlmacenByTipoMovimiento(tipo) {
      this.$refs.jqxLoaderd3.open();
      biApiService
        .getAllTotalPorAlmacenByTipoMovimiento(tipo)
        .then(data => {
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              const element = data[i];

              this.dataD3.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
            }
            this.$refs.donut3.update();
          }
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorAlmacenByTipoMovimiento",
            data.length,
            "OK"
          );
          this.$refs.jqxLoaderd3.close();
        })
        .catch(error => {
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorAlmacenByTipoMovimiento",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd3.close();
        });
    }*/
    getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(tipo) {
      this.$refs.jqxLoaderd3.open();
      biApiService
        .getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId(tipo,this.almacenid,this.temporadaid)
        .then(data => {
          if (data.length > 0) {
            while (this.dataD3.length){
              this.dataD3.pop();
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              this.dataD3.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
            }
            this.$refs.donut3.update();
          }
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId",
            data.length,
            "OK"
          );
          this.$refs.jqxLoaderd3.close();
        })
        .catch(error => {
          while (this.dataD3.length){
              this.dataD3.pop();
            }
          this.$refs.donut3.update();
          util.mostrarEnConsola(
            " TablaStock - getAllTotalPorMarcaByTipoMovimientoByAlmacenIdandTempId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd3.close();
        });
    }
  },
  computed: {
    heightTabla: function() {
      let heightTabla = 300;
      let alturaResto = 440;

      if (this.window.height < heightTabla + alturaResto) {
        return heightTabla;
      } else {
        return this.window.height - alturaResto;
      }
    }
  }
};
</script>

